export default __webpack_public_path__ + "static/media/d.2d72d05d.png";